export type ErrorPayload = {
  [key: string]: any; // index signature for other key-value pairs
  status: number;
};

export type ErrorLabels = {
  [key: string]: string;
};

const errorLabels = (payload: ErrorPayload) => {
  if (!payload) {
    return {};
  }
  const errLabels = {};

  Object.keys(payload).forEach((key) => {
    if (key !== 'status') {
      if (payload[key] && Array.isArray(payload[key])) {
        errLabels[key] = payload[key].join(' ');
      } else {
        errLabels[key] = payload[key];
      }
    }
  });

  return errLabels;
};

export default errorLabels;
